import { Component, ChangeDetectionStrategy } from "@angular/core";
import { ToastService } from "src/app/services/toast.service";
import { DeviceVersionService } from "src/app/services/deviceVersionService";
import { MatDialog } from "@angular/material/dialog";
import { DeviceVersion } from "src/app/models/deviceVersion.model";
import nameOf from "src/app/shared/form/nameOf.helper";
import {
    ConfirmDialogComponent,
    ConfirmDialogData,
} from "src/app/shared/confirmDialog/confirmDialog.component";
import { TimeZoneService } from "src/app/services/timeZone.service";
import { AuthService } from "src/app/services";
import { BaseGridComponent } from "src/app/shared/grid/baseGrid.component";
import { CreateDeviceVersionDialogComponent } from "src/app/modals/createDeviceVersionDialog/createDeviceVersionDialog.component";
import { EditDeviceVersionDialogComponent } from "src/app/modals/editDeviceVersionDialog/editDeviceVersionDialog.component";
import { CommonService } from "src/app/services/common.service";
import { GridViewService } from "src/app/services/grid-view.service";
import { TranslateService } from "@ngx-translate/core";

@Component({
  standalone: false,
    selector: "app-device-version-list",
    templateUrl: "deviceVersionList.component.html",
    changeDetection: ChangeDetectionStrategy.Eager,
    styleUrls: ["deviceVersionList.component.scss"],
})
export class DeviceVersionListComponent extends BaseGridComponent<DeviceVersion> {
    timeZoneLabel: string;

    constructor(
        protected deviceVersionService: DeviceVersionService,
        toastService: ToastService,
        authService: AuthService,
        timeZoneService: TimeZoneService,
        dialog: MatDialog,
        commonService: CommonService,
        gridViewService: GridViewService,
        private translateService: TranslateService,
    ) {
        super(toastService, dialog, commonService, gridViewService);
        this.timeZoneLabel = timeZoneService.createTimeZoneLabel(
            authService.getCurrentUser().userTimeZone,
        );
        this.gridService = deviceVersionService;
        this.displayedColumns = [
            nameOf<DeviceVersion>((x) => x.version),
            "action",
        ];
    }

    add() {
        const dialogRef = this.dialog.open(CreateDeviceVersionDialogComponent, {
            data: {},
            width: "450px",
            disableClose: true,
        });
        this.handleDialogClose(dialogRef);
    }

    edit(deviceVersion: DeviceVersion) {
        const dialogRef = this.dialog.open(EditDeviceVersionDialogComponent, {
            data: { id: deviceVersion.id },
            width: "450px",
            disableClose: true,
        });
        this.handleDialogClose(dialogRef);
    }

    delete(deviceVersion: DeviceVersion) {
        const data: ConfirmDialogData = {
            title: this.translateService.instant("Delete Device Version"),
            message: this.translateService.instant(
                "Are you sure you want to delete device version {{version}}?",
                { version: deviceVersion.version },
            ),
            primaryButtonText: this.translateService.instant("Delete"),
            primaryCallback: () =>
                this.deviceVersionService.delete(deviceVersion.id),
            successMessage: this.translateService.instant(
                "Device version deleted successfully!",
            ),
            secondaryButtonText: this.translateService.instant("Cancel"),
            errorMessage: "",
        };
        const dialogRef = this.dialog.open(ConfirmDialogComponent, {
            data,
            width: "450px",
            disableClose: true,
        });
        this.handleDialogClose(dialogRef);
    }
}
